(ns portal.adserver-configuration-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            [common.debouncer :as debouncer]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.ocp.view :refer [defocp ocp]]
            [common.url-template :as url-tpl]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [portal.adserver-configuration-ocp.db :as form]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal confirm-delete :adserver-configuration/confirm-delete [_]
  [deletion-confirmation
   {:on-submit #(rf/dispatch [:form.adserver-configuration/delete])
    :entity-name "Adserver Configuration"}])

(defui ocp-footer
  [{:keys [mode]}]
  ($ :<>
     (when (= :edit mode)
       ($ Button
          {:variant "contained"
           :color "error"
           :onClick #(rf/dispatch [:modal/open {:id :adserver-configuration/confirm-delete}])}
          "Delete Configuration"))
     ($ Button
        {:variant "contained"
         :type :submit}
        "Save Configuration")))

(defui adserver-field
  [{:keys [mode]}]
  (let [adservers (form/use-adserver-account-options)
        current-adserver (use-subscribe [:form.adserver-configuration/current-adserver])
        {adserver-id :value :as control} (form/use-bind-control [:adserveraccountId])]
    (uix/use-effect (fn []
                      (let [current-adserver (first (filter #(= (:value %) adserver-id) adservers))]
                        (rf/dispatch [:form.adserver-configuration/on-change-adserver current-adserver])))
                    [adserver-id adservers])
    ($ form-field
       {:label "Adserver"
        :err-msg (form/use-error-message [:adserveraccountId])
        :data-testid :adserver-ocp--adserver}
       (if (= :edit mode)
         (str (:name current-adserver))
         (r/as-element
          [dropdown
           (merge control
                  {:options adservers
                   :clearable? true})])))))

(defui advertiser-id-field
  []
  ($ form-field
     {:label "Advertiser ID"
      :err-msg (form/use-error-message [:apiAdvertiserId])}
     ($ input
        (merge (form/use-bind-control [:apiAdvertiserId])
               {:type "text"
                :data-testid "advertiserIdInput"}))))

(defui is-default-field
  []
  ($ checkbox
     (merge (form/use-bind-control [:isDefault])
            {:label "This is the default Adserver Config for this Advertiser"
             :id :isDefault
             :data-testid :adserver-ocp--default})))

(defui autotagging-field
  []
  ($ checkbox
     (merge (form/use-bind-control [:hasAutoTagging])
            {:label "This Advertiser uses DCM auto-tagging"
             :id :hasAutoTagging})))

(defui lowercase-clicktag2-field
  []
  (let [url-context (use-subscribe [:url-context])]
    ($ checkbox
       (merge (form/use-bind-control [:lowercaseClicktag2])
              {:label ($ :<>
                         ($ :span "Enable key value mapping for third party DSP's (lowercase clicktag2) - ")
                         ($ :a {:href (url-tpl/render :docs/article (assoc url-context :slug "24177209454364-DSP-Macros-through-CM360"))
                                :target "_blank"}
                            "View Documentation"))
               :id :hasLowercaseClicktag2}))))

(defocp adserver-configuration-ocp :adserver-configuration/crud
  [{:keys [adserver-configuration]}]
  (uix/use-effect (fn []
                    (rf/dispatch [:form.adserver-configuration/init-form adserver-configuration])
                    (fn []
                      (rf/dispatch [:form.adserver-configuration/destroy]))
                    [adserver-configuration]))
  (let [mode (use-subscribe [:form.adserver-configuration/mode])
        current-adserver (use-subscribe [:form.adserver-configuration/current-adserver])
        api-enabled? (pos? (:apiMethod current-adserver))
        dcm-adserver? (= "Google CM360" (get-in current-adserver [:adserver :name]))]
    ($ ocp
       {:title (if (= :edit mode) "Edit Adserver Configuration" "New Adserver Configuration")
        :on-submit #(rf/dispatch [:form.adserver-configuration/submit])
        :footer ($ ocp-footer {:mode mode})}
       ($ adserver-field {:mode mode})
       (when api-enabled?
         ($ advertiser-id-field))
       (when dcm-adserver?
         ($ autotagging-field))
       ($ is-default-field)
       (when dcm-adserver?
         ($ lowercase-clicktag2-field)))))
